import { CirclePlus, CircleUserRound, Pencil, Play, Square, Trash2 } from "@lucide/vue";
import type { Component } from "vue";

export type ActivityVariant = "success" | "warning" | "danger" | "default";

export interface ActivityStyle {
  variant: ActivityVariant;
  icon: Component;
}

/** Available style sets. Add "deposit" (and its preset below) when the feature lands. */
export type ActivityStyleVariant = "default";

const DEFAULT_STYLE: ActivityStyle = { variant: "default", icon: CircleUserRound };

const presets: Record<ActivityStyleVariant, Record<string, ActivityStyle>> = {
  default: {
    created: { variant: "danger", icon: CirclePlus },
    Started: { variant: "success", icon: Play },
    Closed: { variant: "danger", icon: Square },
    deleted: { variant: "success", icon: Trash2 },
    updated: { variant: "warning", icon: Pencil },
  },
};

export function resolveActivityStyle(styleVariant: ActivityStyleVariant, description: string): ActivityStyle {
  return presets[styleVariant][description] ?? DEFAULT_STYLE;
}
